import React from "react";
import { Page, Text, View, Image } from "@react-pdf/renderer";

import CDK_Logo from "../../../images/CDKGlobalWM_BLK.jpg";

import styles from "../PDFStyles/NewFormNo11";
import commonStyles from "../PDFStyles/common";

import {
  getFormattedDate,
  getGenderName,
  getMaritalName,
  getFullName
} from "../../../util/helpers";

import {
  getDeclarationPlace,
  getFatherOrMotherOrSpouseName,
  getBankIFSCCode
} from "../../../util/onBoardingDataFilters";

export const NewFormNo11 = React.memo(
  ({ candidateDetails, genders, maritalStatusList, otherBankDetails }) => {
    const {
      adhaarNumber,
      bankAccountNumber,
      bankIFSCCode,
      birthDate,
      contactNumber,
      countryOrigin,
      declarationDate,
      declarationPlace,
      ePFIsFatherOrMotherOrSpouse,
      emailId,
      familyMembers,
      gender,
      isEarlierEPF1952Scheme,
      isEarlierEPF1995Scheme,
      isInternationalWorker,
      maritalStatus,
      panCardNo,
      passportNo,
      passportValidityFrom,
      passportValidityTo,
      pfUanNo,
      previousEmpExitDate,
      previousPFNumber,
      schemeCertificateNumber
    } = candidateDetails;

    const { otherIFSCCode } = otherBankDetails;

    const candidateFullName = getFullName(candidateDetails);

    const fatherOrMotherOrSpouseName = getFatherOrMotherOrSpouseName(
      ePFIsFatherOrMotherOrSpouse,
      familyMembers
    );

    return (
      <Page size="A4" style={commonStyles.page}>
        <Image style={commonStyles.cdkLogo} src={CDK_Logo} />
        <View style={commonStyles.header}>
          <Text style={commonStyles.text}>
            A New Form No – 11 –Declaration Form
          </Text>
          <Text style={commonStyles.textItalic}>
            (To be retained by employer for future reference)
          </Text>
          <Text style={commonStyles.fontBold}>
            EMPLOYEES’ PROVIDENT FUND ORGANIZATION
          </Text>
          <Text style={commonStyles.fontBold}>
            EMPLOYEES’ PROVIDENT FUNDS SCHEME, 1952 (PARAGRAPH-34 & 57) &
          </Text>
          <Text style={commonStyles.fontBold}>
            EMPLOYEES’ PENSION SCHEME, 1995 (PARAGRAPH-24)
          </Text>
          <Text style={commonStyles.fontBold}>
            (DECLARATION BY A PERSON TAKING UP EMPLOYMENT IN AN ESTABLISHMENT ON
            WHICH EPF SCHEME, 1952
          </Text>
          <Text
            style={{
              ...commonStyles.fontBold,
              ...commonStyles.paddingBottom10
            }}
          >
            AND/OR EPS, 1995 IS APPLICABLE)
          </Text>
        </View>
        <View style={commonStyles.table}>
          <View style={commonStyles.tableRow}>
            <View style={styles.serialNumberCol}>
              <Text style={styles.tableCell}>1</Text>
            </View>
            <View style={styles.namesCol}>
              <Text style={styles.tableCell}>Name of the member</Text>
            </View>
            <View style={styles.valuesCol}>
              <Text style={styles.tableCell}>{candidateFullName}</Text>
            </View>
          </View>
          <View style={commonStyles.tableRow}>
            <View style={styles.serialNumberCol}>
              <Text style={styles.tableCell}>2</Text>
            </View>
            <View style={styles.namesCol}>
              <Text style={styles.tableCell}>
                Father's / Mother's / Spouse's names
              </Text>
            </View>
            <View style={styles.valuesCol}>
              <Text style={styles.tableCell}>{fatherOrMotherOrSpouseName}</Text>
            </View>
          </View>
          <View style={commonStyles.tableRow}>
            <View style={styles.serialNumberCol}>
              <Text style={styles.tableCell}>3</Text>
            </View>
            <View style={styles.namesCol}>
              <Text style={styles.tableCell}>Date of Birth;(DD/MM/YYYY)</Text>
            </View>
            <View style={styles.valuesCol}>
              <Text style={styles.tableCell}>
                {getFormattedDate(birthDate)}
              </Text>
            </View>
          </View>
          <View style={commonStyles.tableRow}>
            <View style={styles.serialNumberCol}>
              <Text style={styles.tableCell}>4</Text>
            </View>
            <View style={styles.namesCol}>
              <Text style={styles.tableCell}>
                Gender ;(Male/Female/Transgender)
              </Text>
            </View>
            <View style={styles.valuesCol}>
              <Text style={styles.tableCell}>
                {getGenderName(gender, genders)}
              </Text>
            </View>
          </View>
          <View style={commonStyles.tableRow}>
            <View style={styles.serialNumberCol}>
              <Text style={styles.tableCell}>5</Text>
            </View>
            <View style={styles.namesCol}>
              <Text style={styles.tableCell}>
                Marital Status ;(Married/Unmarried/Widow/Widower/Divorcee)
              </Text>
            </View>
            <View style={styles.valuesCol}>
              <Text style={styles.tableCell}>
                {getMaritalName(maritalStatus, maritalStatusList, true)}
              </Text>
            </View>
          </View>
          <View style={commonStyles.tableRow}>
            <View style={styles.serialNumberCol}>
              <Text style={styles.tableCell}>6</Text>
            </View>
            <View style={styles.namesCol}>
              <Text style={styles.tableCell}>(a)Email ID</Text>
              <View style={styles.hrLine} />
              <Text style={styles.tableCell}>(b)Mobile No;</Text>
            </View>
            <View style={styles.valuesCol}>
              <Text style={styles.tableCell}>{emailId}</Text>
              <View style={styles.hrLine} />
              <Text style={styles.tableCell}>{contactNumber}</Text>
            </View>
          </View>
          <View style={commonStyles.tableRow}>
            <View style={styles.serialNumberCol}>
              <Text style={styles.tableCell}>7</Text>
            </View>
            <View style={styles.namesCol}>
              <Text style={styles.tableCell}>
                WHETHER EARLIER A MEMBER OF THE EMPLOYEES’ PROVIDENT FUND
                SCHEME,1952?
              </Text>
            </View>
            <View style={styles.valuesCol}>
              <Text style={styles.tableCell}>
                {isEarlierEPF1952Scheme ? "YES" : "NO"}
              </Text>
            </View>
          </View>
          <View style={commonStyles.tableRow}>
            <View style={styles.serialNumberCol}>
              <Text style={styles.tableCell}>8</Text>
            </View>
            <View style={styles.namesCol}>
              <Text style={styles.tableCell}>
                WHETHER EARLIER A MEMBER OF THE EMPLOYEES’ PENSION SCHEME, 1995?
              </Text>
            </View>
            <View style={styles.valuesCol}>
              <Text style={styles.tableCell}>
                {isEarlierEPF1995Scheme ? "YES" : "NO"}
              </Text>
            </View>
          </View>
          <View style={commonStyles.tableRow}>
            <View style={styles.serialNumberCol}>
              <Text style={styles.tableCell}>9</Text>
            </View>
            <View style={styles.namesCol}>
              <Text style={{ ...styles.tableCell, ...commonStyles.fontBold }}>
                PREVIOUS EMPLOYMENT DETAILS;(if Yes to 7 AND/OR 8above)
              </Text>
              <View style={styles.hrLine} />
              <Text style={styles.tableCell}>a)UNIVERSAL ACCOUNT NUMBER</Text>
              <View style={styles.hrLine} />
              <Text style={styles.tableCell}>b)PREVIOUS PF Account Number</Text>
              <View style={styles.hrLine} />
              <Text style={styles.tableCell}>
                c)DATE OF EXIT From PREVIOUS Employment (DD/MM/YYYY)
              </Text>
              <View style={styles.hrLine} />
              <Text style={styles.tableCell}>
                d)Scheme Certificate No.(if Issued)
              </Text>
            </View>
            <View style={styles.valuesCol}>
              <Text style={styles.employmentEmptyCell}></Text>
              <View style={styles.hrLine} />
              <Text style={styles.tableCell}>{pfUanNo || " "}</Text>
              <View style={styles.hrLine} />
              <Text style={styles.tableCell}>
                {previousPFNumber || " "}
              </Text>
              <View style={styles.hrLine} />
              <Text style={styles.tableCell}>
              {getFormattedDate(previousEmpExitDate) || " "}
              </Text>
              <View style={styles.hrLine} />
              <Text style={styles.tableCell}>
                {schemeCertificateNumber || " "}
              </Text>
            </View>
          </View>
          <View style={commonStyles.tableRow}>
            <View style={styles.serialNumberCol}>
              <Text style={styles.tableCell}>10</Text>
            </View>
            <View style={styles.namesCol}>
              <Text style={styles.tableCell}>a)International Worker:</Text>
              <View style={styles.hrLine} />
              <Text style={styles.tableCell}>
                b)if Yes, State Country of origin (India/Name of other Country)
              </Text>
              <View style={styles.hrLine} />
              <Text style={styles.tableCell}>c)Passport No,</Text>
              <View style={styles.hrLine} />
              <Text style={styles.tableCell}>
                d)Validity of Passport (DD/MM/YYYY) to (DD/MM/YYYY)
              </Text>
            </View>
            <View style={styles.valuesCol}>
              <Text style={styles.tableCell}>
                {isInternationalWorker == 1 ? "YES" : "NO"}
              </Text>
              <View style={styles.hrLine} />
              <Text style={styles.tableCell}>{countryOrigin || " "}</Text>
              <View style={styles.hrLine} />
              <Text style={styles.tableCell}>{passportNo || " "}</Text>
              <View style={styles.hrLine} />
              <Text style={styles.tableCell}>
                {(passportValidityFrom &&
                  passportValidityTo &&
                  `(${getFormattedDate(
                    passportValidityFrom
                  )}) to (${getFormattedDate(passportValidityTo)})`) ||
                  " "}
              </Text>
            </View>
          </View>
          <View style={commonStyles.tableRow}>
            <View style={styles.serialNumberCol}>
              <Text style={styles.tableCell}>11</Text>
            </View>
            <View style={styles.namesCol}>
              <Text style={{ ...commonStyles.tableRow, ...styles.tableCell }}>
                <Text style={commonStyles.fontBold}>KYC Details;</Text>(attach
                self-attested copies of following KYCs)
              </Text>
              <View style={styles.hrLine} />
              <Text style={styles.tableCell}>
                a)Bank Account No.& IFSC Code
              </Text>
              <View style={styles.hrLine} />
              <Text style={styles.tableCell}>b)AADHAR Number</Text>
              <View style={styles.hrLine} />

              <Text style={styles.tableCell}>
                C)Permanent Account Number (PAN),if available
              </Text>
            </View>
            <View style={styles.valuesCol}>
              <Text style={styles.emptyCell}></Text>
              <View style={styles.hrLine} />
              <Text style={styles.tableCell}>
                {[bankAccountNumber || "-", getBankIFSCCode(bankIFSCCode, otherIFSCCode)]
                  .filter(value => value)
                  .join(" & ") || " "}
              </Text>
              <View style={styles.hrLine} />
              <Text style={styles.tableCell}>{adhaarNumber}</Text>
              <View style={styles.hrLine} />
              <Text style={styles.tableCell}>{panCardNo}</Text>
            </View>
          </View>
        </View>

        <Image break style={commonStyles.cdkLogo} src={CDK_Logo} />
        <View style={styles.bottomText}>
          <Text
            style={{
              ...commonStyles.textCenter,
              ...commonStyles.textUnderline,
              ...commonStyles.fontBold,
              ...commonStyles.paddingBottom10
            }}
          >
            UNDETAKING
          </Text>
          <Text>
            1) Certified that the particular are true to the best of my
            knowledge.
          </Text>
          <Text>
            2) I authorize EPFO to use my Aadhar for
            verification/authentication/eKYC purpose for service delivery.
          </Text>
          <Text style={commonStyles.paddingBottom10}>
            3) Kindly transfer the founds and service details,if applicable,from
            the previous PF account as declared above to the present PF
            Account.(The transfer would be possible only if the identified KYC
            detail approved by previous employer has been verified by present
            employer using his Digital Signature Certificate)
          </Text>
          <Text>
            4) In case of changes in above details,the same will be intimated to
            employer at the earliest.
          </Text>
          <View style={styles.signature}>
            <View style={styles.employeeSignature}>
              <View style={commonStyles.flexDirectionRow}>
                <Text style={styles.signatureText}>DATE:</Text>
                <Text>{getFormattedDate(declarationDate)}</Text>
              </View>
              <View style={commonStyles.flexDirectionRow}>
                <Text style={styles.signatureText}>PLACE:</Text>
                <Text>{getDeclarationPlace(declarationPlace)}</Text>
              </View>
            </View>
            <View style={styles.employeeSignature}>
              <Text>{candidateFullName}</Text>
              <Text>__________________________________</Text>
              <Text style={styles.signatureText}>SIGNATURE OF MEMBER</Text>
            </View>
          </View>
          <Text
            className="pt-3 my-3"
            style={{
              ...styles.decalarationHeading,
              ...commonStyles.textCenter,
              ...commonStyles.fontBold
            }}
          >
            DECLARATION BY PRESENT EMPLOYER
          </Text>
          <Text>
            A. THE MEMBER Mr./Ms./Mrs. ................................ HAS
            JOINED ON ....................... AND HAS BEEN ALLOTTED PF MEMBER ID
            ...................................................
          </Text>
          <Text>
            B. IN CASE THE PERSON WAS EARLIER NOT A MEMBER OF EPF SCHEME, 1952
            AND EPS, 1995:
          </Text>
          <View
            style={{ ...commonStyles.paddingLeft10, ...commonStyles.textLight }}
          >
            <Text>
              □ {"     (POST ALLOTMENT OF UAN)THE UAN ALLOWTED FOR MEMBER IS........."}
            </Text>

            <Text>
              □ {"     PLEASE TICK THE APPROPRIATE ACTION"}
            </Text>
          </View>
          <View style={styles.KYCDetails}>
            <Text>THE KYC DETAILS OF THE ABOVE MEMBER IN THE UAN DATABASE</Text>
            <View style={commonStyles.paddingLeft10}>
              <View style={commonStyles.flexDirectionRow}>
                <View style={styles.checkBox} />
                <Text>HAVE NOT BEEN UPLOADED</Text>
              </View>
              <View style={commonStyles.flexDirectionRow}>
                <View style={styles.checkBox} />
                <Text>HAVE BEEN UPLOADED BUT NOT APPROVED</Text>
              </View>
              <View style={commonStyles.flexDirectionRow}>
                <View style={styles.checkBox} />
                <Text>HAVE BEEN UPLOADED AND APPROVED WITH DSC</Text>
              </View>
            </View>
          </View>
          <Text>
            C. {"      IN CASE THE PERSON WAS EARLIER A MEMBER OF EPF SCHEME, 1952 AND EPS, 1995:"} 
          </Text>
          <Text
            style={{ ...commonStyles.paddingLeft10, ...commonStyles.textLight }}
          >
            □ {"    The above PF Account number/UAN of the member's as mentioned in (A) above has been tagged with his/her"}
          </Text>
          <Text>
            UAN/Previous member ID as declared by member . PLEASE TICK THE
          </Text>
          <Text style={commonStyles.paddingLeft10}>
            {".   PLEASE TICK THE APPROPRIATE OPTION:-"}
          </Text>
          <View
            style={{
              ...commonStyles.flexDirectionRow,
              ...styles.paddingLeft30
            }}
          >
            <View style={styles.checkBox} />
            <Text>
              THE KYC DETAILS OF THE ABOVE MEMBER IN THE UAN DATABASE HAVE BEEN
              APPROVED WITH
            </Text>
          </View>
          <Text>
            DIGITAL SIGNATURE CERTIFICATE AND TRANSFER REQUEST HAS BEEN
            GENERATED ON POR
          </Text>
          <View
            style={{
              ...commonStyles.flexDirectionRow,
              ...commonStyles.paddingLeft10
            }}
          >
            <View style={styles.checkBox} />
            <Text>
              AS THE DSC OF ESTABLISHMENT ARE NOT REGISTERED WITH EPFO, THE
              MEMBER HAS BEEN INFORMED TO FILE
            </Text>
          </View>
          <Text>
            PHYSICAL CLAIM (FORM- 13) FOR TRANSFER OF FUNDS FROM HIS PREVIOUS
            ESTABLISHMENT.
          </Text>
          <View style={styles.bottomSignature}>
            <Text>DATE:</Text>
            <Text>SIGNATURE OF EMPLOYER WITH SEAL OF ESTABLISHMENT</Text>
          </View>
        </View>
      </Page>
    );
  }
);

export default NewFormNo11;
